import React from "react";
import { gradeColors } from "../sustainabilityIndex/gradeColors";
import { asDisplayLabel } from "../../utils/benchmarking/benchmarkEngine";

function formatScore(value) {
  if (value == null || !Number.isFinite(value)) return "—";
  return Number(value).toFixed(1);
}

function formatMetaPart(value) {
  return asDisplayLabel(value, "");
}

function MetricCard({ label, value, subtext, accent, large }) {
  return (
    <div className={`benchmark-dashboard-metric${large ? " benchmark-dashboard-metric--large" : ""}`}>
      <span className="benchmark-dashboard-metric__label">{label}</span>
      <span
        className="benchmark-dashboard-metric__value"
        style={accent ? { color: accent } : undefined}
      >
        {value}
      </span>
      {subtext ? <span className="benchmark-dashboard-metric__sub">{subtext}</span> : null}
    </div>
  );
}

export default function BenchmarkDashboard({ dashboard, benchmarkLabel, orgName }) {
  if (!dashboard) return null;

  const grade = String(dashboard.esgRatingGrade || "—").trim();
  const gradeColor = gradeColors[grade.charAt(0)] || "#02b880";
  const gap = dashboard.scoreGap;

  return (
    <section className="benchmark-dashboard" aria-label="Benchmark dashboard">
      <div className="benchmark-dashboard__hero">
        <div className="benchmark-dashboard__hero-main">
          <p className="benchmark-dashboard__eyebrow">Benchmark Dashboard</p>
          <h2 className="benchmark-dashboard__title">
            {orgName || "Your organization"}
          </h2>
          <p className="benchmark-dashboard__subtitle">
            Compared against <strong>{formatMetaPart(benchmarkLabel) || "benchmark"}</strong>
            {formatMetaPart(dashboard.sector)
              ? ` · ${formatMetaPart(dashboard.sector)}`
              : ""}
            {formatMetaPart(dashboard.country)
              ? ` · ${formatMetaPart(dashboard.country)}`
              : ""}
          </p>
        </div>
        <div className="benchmark-dashboard__hero-grade" style={{ borderColor: gradeColor }}>
          <span className="benchmark-dashboard__hero-grade-label">SI Rating Grade</span>
          <span className="benchmark-dashboard__hero-grade-value" style={{ color: gradeColor }}>
            {grade}
          </span>
        </div>
      </div>

      <div className="benchmark-dashboard__grid">
        <MetricCard
          label="Overall Sustainability Score"
          value={formatScore(dashboard.overallSustainabilityScore)}
          subtext="Your SI composite score (0–100)"
          large
        />
        <MetricCard
          label="Overall Benchmark Score"
          value={formatScore(dashboard.overallBenchmarkScore)}
          subtext={
            dashboard.overallBenchmarkScore == null
              ? "No reference available for this benchmark"
              : `${formatMetaPart(benchmarkLabel)} · grade ${dashboard.benchmarkGrade}`
          }
          large
        />
        <MetricCard
          label="Score Gap"
          value={gap == null ? "—" : `${gap >= 0 ? "+" : ""}${gap.toFixed(1)}`}
          subtext="Your score minus the benchmark score"
          accent={gap == null ? undefined : gap >= 0 ? "#059669" : "#dc2626"}
        />
        <MetricCard
          label="Assessment Year"
          value={dashboard.assessmentYear ?? "—"}
          subtext="Reporting period for this benchmark"
        />
      </div>
    </section>
  );
}
